import React, { memo, useEffect, useState } from "react";
import {
  Checkbox,
  CircularProgress,
  Fade,
  Menu,
  MenuItem,
  Modal,
  Tooltip,
} from "@mui/material";
//img
import viewIcon from "../../../assets/images/svg/viewtech.svg";
import fileIcon from "../../../assets/images/svg/file@.svg";
import editIcon from "../../../assets/images/svg/File Edit.svg";
import dltIcon from "../../../assets/images/svg/Delete.svg";
import sortIcon from "../../../assets/images/svg/Sort.svg";
import profileImg from "../../../assets/images/png/profile-pic.jpg";
import ownBidIcon from "../../../assets/images/svg/vendorProfile/satuatoryblack.svg";
import bidSuccessImg from "../../../assets/images/svg/bidSuccessCheck.svg";
//css
import styles from "./DataTable.module.css";
//components
import { saveAs } from "file-saver";
import ImgFrame from "../ImageFrame/ImgFrame";
import DButton from "../../Dashboard/DashboardButtons/Dbutton";
import DButtonOutlined from "../../Dashboard/DashboardButtons/dButtonOutlined";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import HeaderTitle from "../HeaderTitle/HeaderTitle";
import PopupFrame from "../../Popups/PopupFrame/PopupFrame";
import InfoLabel from "../InfoLabel/InfoLabel";
import SwitchButton from "../../Dashboard/SwitchButton/SwitchButton";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { formatInrAmount } from "../../../utils/currencyFormat";

const DataTable = ({
  headings,
  tableData,
  actions,
  selection,
  viewBtn,
  editBtn,
  deleteBtn,
  viewClick,
  editClick,
  deleteClick,
  customClass,
  sorting,
  file,
  selectBidBtn,
  onSelectBid,
  onUnSelectBid,
  ownBid,
  vendorConfidential,
  vendorNameConfidential,
  ownBidHeading,
  tableSize,
  org,
  buyer,
  bulkData,
  isLoading,
  errorMessage,
  itemsTable,
  selectedRowsList,
  clearAllSelectedRows,
  hasBidIteration,
  maxBidIterationCount,
  disableSelectAll,
  stickyHead,
  setSortingColumnName,
  sortingColumnName,
  setSortingOrder,
  sortingOrder,
  serverSortableFields = [],
  stickyFirstColumn = false,
  stickyFirstColumnOffset = 0,
  tableFixedHeight,
  toggleOnChange,
  fixedLayout = false,
  viewTooltip,
  editTooltip,
  deleteTooltip,
  viewTooltipText,
  editTooltipText,
  deleteTooltipText,
}) => {
  const [data, setData] = useState(tableData);
  const resolvedViewTooltip = viewTooltip ?? viewTooltipText ?? "View";
  const resolvedEditTooltip = editTooltip ?? editTooltipText ?? "Edit";
  const resolvedDeleteTooltip = deleteTooltip ?? deleteTooltipText ?? "Delete";
  let checkIsBidSelected = bulkData?.map((e) => e.status);

  let quoteOptions = headings.filter((e) => e.label === "Quote Iteration")[0]
    ?.DropdownOptions;

  useEffect(() => {
    tableData && setData(tableData);
  }, [tableData]);

  const location = useLocation();

  const [bidSelected, setBidSelected] = useState(false);

  //roles
  const loginData = useSelector((state) => state.loginData.value);

  const [roles, setRoles] = useState({
    Admin: "",
    Buyer: "",
    Vendor: "",
  });
  useEffect(() => {
    if (clearAllSelectedRows) {
      setSelectedRows([]);
      setSelectedRowObj([]);
    }
  }, [clearAllSelectedRows]);

  useEffect(() => {
    setRoles({
      Admin:
        loginData?.access_type === "admin" ||
        loginData?.access_type === "Admin",
      Buyer:
        loginData?.access_type === "buyer" ||
        loginData?.access_type === "Buyer",
      Vendor:
        loginData?.access_type === "vendor admin" ||
        data?.access_type === "Vendor admin" ||
        loginData?.access_type === "vendor contact" ||
        data?.access_type === "Vendor contact",
    });
  }, [location.pathname, data, bidSelected]);

  const [selectedBidRows, setSelectedBidRows] = useState([]);

  const [sortedField, setSortedField] = useState(sortingColumnName ?? null);
  const [sortOrder, setSortOrder] = useState(sortingOrder ?? "asc");

  const [selectedRows, setSelectedRows] = useState([]);
  const [selectedRowObj, setSelectedRowObj] = useState([]);

  // const handleRowSelect = (rowId, row) => {
  //   const selectedIndex = selectedRows?.indexOf(rowId);
  //   let newSelectedRows = [];
  //   let newSelectedRowObj = [];

  //   if (selectedIndex === -1) {
  //     newSelectedRows = [...selectedRows, rowId];
  //     newSelectedRowObj.push(row);
  //   } else {
  //     newSelectedRows = selectedRows?.filter((id) => id !== rowId);
  //     newSelectedRowObj = newSelectedRowObj?.filter((e) => e.token !== row.token);
  //   }

  //   // in bid iteration selection have to select the each row using its token but have to send the vendor_id
  //   // of the each row in selection in specifically --> RFQ -> request resubmit quote

  //   // let filteredMain = newSelectedRows.flatMap((el) => (
  //   //   data?.filter((el2) => (el === el2?.token))
  //   // ))

  //   // let filteredVendorId = filteredMain.map((el) => el?.vendor_id);

  //   // selectedRowsList(filteredVendorId);
  //   setSelectedRows(newSelectedRows, newSelectedRowObj);
  //   selectedRowsList(newSelectedRows, newSelectedRowObj);
  // };

  const handleRowSelect = (rowId, row) => {
    const selectedIndex = selectedRows.indexOf(rowId);

    let newSelectedRows = [...selectedRows];
    let newSelectedRowObj = [...selectedRowObj];

    if (selectedIndex === -1) {
      newSelectedRows = [...selectedRows, rowId];
      newSelectedRowObj = [...selectedRowObj, row];
    } else {
      newSelectedRows = selectedRows.filter((id) => id !== rowId);
      newSelectedRowObj = newSelectedRowObj.filter(
        (selectedRow) => selectedRow.token !== row.token,
      );
    }

    setSelectedRowObj(newSelectedRowObj);
    setSelectedRows(newSelectedRows, newSelectedRowObj);
    selectedRowsList(newSelectedRows, newSelectedRowObj);
  };

  const handleSelectAllRows = (event) => {
    if (event.target.checked) {
      const newSelectedRowTokens = data && data?.map((row, i) => row.token);
      const newSelectedRows = data && data?.map((row, i) => row);
      setSelectedRows(newSelectedRowTokens, newSelectedRows);
      selectedRowsList(newSelectedRowTokens, newSelectedRows);

      // in bid iteration selection have to select the each row using its token but have to send the vendor_id
      // of the each row in selection in specifically --> RFQ -> request resubmit quote

      // let filteredMain = newSelectedRows.flatMap((el) => (
      //   data?.filter((el2) => (el === el2?.token))
      // ))

      // let filteredVendorId = filteredMain.map((el) => el?.vendor_id);

      // selectedRowsList(filteredVendorId);
    } else {
      setSelectedRows([]);
      selectedRowsList([]);
    }
  };

  const normalizeSortOrder = (value) => {
    const normalizedValue = String(value || "").toLowerCase();
    return normalizedValue === "desc" || normalizedValue === "descending"
      ? "desc"
      : "asc";
  };

  const handleSort = (field) => {
    const isServerSortableField =
      Array.isArray(serverSortableFields) &&
      serverSortableFields.includes(field);
    const currentField = isServerSortableField
      ? (sortingColumnName ?? sortedField)
      : sortedField;
    const currentOrder = isServerSortableField
      ? (sortingOrder ?? sortOrder)
      : sortOrder;
    let newSortOrder = "asc";

    if (currentField === field && normalizeSortOrder(currentOrder) === "asc") {
      newSortOrder = "desc";
    }

    setSortedField(field);
    setSortOrder(newSortOrder);

    if (isServerSortableField && typeof setSortingColumnName === "function") {
      setSortingColumnName(field);
    }

    if (isServerSortableField && typeof setSortingOrder === "function") {
      setSortingOrder(newSortOrder);
    }

    if (
      isServerSortableField &&
      (typeof setSortingColumnName === "function" ||
        typeof setSortingOrder === "function")
    ) {
      return;
    }

    const sortedData = [...data];

    sortedData.sort((a, b) => {
      const valueA = a[field];
      const valueB = b[field];

      if (typeof valueA === "number" && typeof valueB === "number") {
        return newSortOrder === "asc" ? valueA - valueB : valueB - valueA;
      } else {
        const compareResult = valueA?.localeCompare(valueB);
        return newSortOrder === "asc" ? compareResult : -compareResult;
      }
    });

    setData(sortedData);
  };

  const isSelected = (rowId) => selectedRows.indexOf(rowId) !== -1;
  const isSelectedBid = (rowId) => selectedBidRows.indexOf(rowId) !== -1;

  const handleSelectBid = (rowId, row) => {
    onSelectBid && onSelectBid(row.token);
    setSelectedBidRows([rowId]);
  };

  const handleUnselectBid = (rowId, row) => {
    onUnSelectBid && onUnSelectBid(row.token);
    setSelectedBidRows([]);
  };

  const cloudFrontURL = process.env.REACT_APP_CLOUDFRONT_URL;

  // view description
  const [bidDescription, setBidDescription] = useState();
  const [descriptionPopup, setDescriptionPopup] = useState({
    open: false,
    close: false,
  });

  const handleOpenViewDescription = (description) => {
    setDescriptionPopup({
      open: true,
      close: false,
    });
    setBidDescription();
    setBidDescription(description);
  };

  const handleCloseViewDescription = () => {
    setDescriptionPopup({
      open: false,
      close: true,
    });
  };

  const viewDescriptionHeading = (
    <HeaderTitle titleText={"Description"} customclass={styles.popupHeading} />
  );

  const viewDescriptionContent = [
    // <p className={styles.bidDescription}>{bidDescription}</p>
    <InfoLabel
      customClass={styles.bidDescription}
      value={bidDescription}
      size={"100%"}
      maxLength={"350"}
    />,
  ];

  const viewDescriptionAction = [
    <DButtonOutlined
      label={"Cancel"}
      onClick={handleCloseViewDescription}
      btnWidth={"17rem"}
      btnHeight={"4rem"}
    />,
  ];

  //open dropdown states and handlers
  const [anchorEl, setAnchorEl] = useState(null);

  const handleOpenDropdownHeading = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCloseDropdownHeading = () => {
    setAnchorEl(null);
  };

  return (
    <div className={styles.container}>
      <div
        className={`${styles.datatable_wrapper} ${customClass}`}
        style={{
          maxHeight: tableFixedHeight && tableFixedHeight,
        }}
      >
        <table
          style={{
            width: tableSize || "100vw",
            tableLayout: fixedLayout ? "fixed" : "auto",
          }}
        >
          <thead className={`${stickyHead && styles.stickyHead}`}>
            <tr>
              {selection && (
                <th
                  className={`${roles.Admin && styles.defaultHead} ${
                    roles.Buyer && styles.buyerHead
                  } ${roles.Vendor && styles.vendorHead}`}
                >
                  <Checkbox
                    disabled={disableSelectAll}
                    sx={{ "& .MuiSvgIcon-root": { fontSize: "22px" } }}
                    size="medium"
                    indeterminate={
                      selectedRows.length > 0 &&
                      selectedRows.length < data?.length
                    }
                    checked={
                      selectedRows.length > 0 &&
                      selectedRows.length === data?.length
                    }
                    onChange={handleSelectAllRows}
                  />
                </th>
              )}
              {headings.map((heading) => (
                <th
                  key={heading.field}
                  className={`${roles.Admin && styles.defaultHead} ${
                    roles.Buyer && styles.buyerHead
                  } ${roles.Vendor && styles.vendorHead}`}
                  style={{
                    whiteSpace: "nowrap",
                    textAlign:
                      heading.label === "Status" ||
                      heading.label === "Bid Status"
                        ? "center"
                        : "left",
                    width:
                      heading.label === "Status"
                        ? "15rem"
                        : heading.col_width && heading.col_width,
                    minWidth:
                      heading.label === "Status"
                        ? "15rem"
                        : heading.minWidth || heading.col_width,
                    ...(stickyFirstColumn &&
                      headings?.[0]?.field === heading.field && {
                        position: "sticky",
                        left: stickyFirstColumnOffset,
                        zIndex: 4,
                        backgroundColor: "#e0e9ee",
                        boxShadow: "2px 0 0 0 #e2e8f0 inset",
                      }),
                  }}
                >
                  {/* show only field heading - default*/}
                  {!heading.selectable_header && heading.label}
                  {/* show only field heading - default*/}

                  {sorting &&
                    !heading.selectable_header &&
                    heading.label !== "Bid Status" &&
                    heading.sortable !== false && (
                      <button
                        onClick={() => {
                          handleSort(heading.field);
                        }}
                        style={{
                          outline: "none",
                        }}
                      >
                        <img src={sortIcon} className={styles.sortIcon} />
                      </button>
                    )}

                  {heading.selectable_header && (
                    <span
                      className={`${styles.flex} ${styles.pointer}`}
                      onClick={handleOpenDropdownHeading}
                      style={{ whiteSpace: "nowrap" }}
                    >
                      {heading.label}
                      <ArrowDropDownIcon
                        sx={{
                          width: "25px",
                          fontSize: "2rem",
                        }}
                      />
                    </span>
                  )}

                  {heading.selectable_header && (
                    <Menu
                      anchorEl={anchorEl}
                      open={Boolean(anchorEl)}
                      sx={{
                        ".MuiMenu-paper": {
                          marginTop: "0.6rem",
                          marginLeft: "2rem",
                          // top: '886px',
                          // left: '1058px',
                          boxShadow: "0px 6px 24px #00000017",
                        },
                      }}
                      onClose={handleCloseDropdownHeading}
                    >
                      {heading.selectable_header &&
                        quoteOptions?.map((option, index) => {
                          return (
                            <MenuItem
                              sx={{
                                width: "100%",
                                textAlign: "center",
                                fontSize: "1.4rem",
                                fontFamily: "gilroyMedium",
                              }}
                              key={index}
                              onClick={() => {
                                handleCloseDropdownHeading();
                                heading.selectable_header &&
                                  heading?.onClick &&
                                  heading?.onClick(
                                    option?.toLowerCase(),
                                    option,
                                  );
                              }}
                            >
                              {option || <em></em>}
                            </MenuItem>
                          );
                        })}
                    </Menu>
                  )}
                </th>
              ))}
              {actions && (
                <th
                  className={`${roles.Admin && styles.defaultHead} ${
                    roles.Buyer && styles.buyerHead
                  } ${roles.Vendor && styles.vendorHead}`}
                  style={{
                    textAlign: "center",
                    position: "sticky",
                    right: 0,
                    zIndex: 4,
                    backgroundColor: "#e0e9ee",
                    boxShadow: "-2px 0 0 0 #e2e8f0 inset",
                  }}
                >
                  Actions
                </th>
              )}
              {file && (
                <th
                  className={`${roles.Admin && styles.defaultHead} ${
                    roles.Buyer && styles.buyerHead
                  } ${roles.Vendor && styles.vendorHead}`}
                  style={{
                    width: "8rem",
                    minWidth: "8rem",
                    textAlign: "center",
                  }}
                >
                  File
                </th>
              )}
              {selectBidBtn && (
                <th
                  className={`${roles.Admin && styles.defaultHead} ${
                    roles.Buyer && styles.buyerHead
                  } ${roles.Vendor && styles.vendorHead}`}
                  style={{
                    width: "11rem",
                    minWidth: "11rem",
                  }}
                ></th>
              )}
              {ownBidHeading && (
                <th
                  className={`${roles.Admin && styles.defaultHead} ${
                    roles.Buyer && styles.buyerHead
                  } ${roles.Vendor && styles.vendorHead}`}
                  style={{
                    width: "11rem",
                    minWidth: "11rem",
                  }}
                ></th>
              )}
            </tr>
          </thead>
          {!isLoading && (
            <tbody>
              {data &&
                data?.map((row, i) => (
                  <tr
                    key={`${row?.id ?? row?.token ?? row?.rfq_token ?? row?.PO_number ?? "row"}-${row?.sl_no ?? i}`}
                    className={`${
                      row?.bid_version_int === maxBidIterationCount &&
                      isSelected(row.token)
                        ? styles.activeRow
                        : ""
                    }`}
                    // className={`${
                    //   isSelected(row.token) ? styles.activeRow : ""
                    // }`}
                  >
                    {selection && (
                      <td>
                        <Checkbox
                          sx={{ "& .MuiSvgIcon-root": { fontSize: "22px" } }}
                          checked={
                            row?.bid_version_int === maxBidIterationCount
                              ? isSelected(row.token)
                              : false
                            // isSelected(row.token)
                          }
                          onChange={() => handleRowSelect(row.token, row)}
                          //to disable the old iteration rowsselect
                          disabled={
                            row?.bid_version_int !== maxBidIterationCount
                          }
                        />
                      </td>
                    )}
                    {headings.map((heading) => (
                      <td
                        key={heading.field}
                        style={{
                          whiteSpace: "nowrap",
                          width:
                            heading.label === "Status"
                              ? "130px"
                              : heading.col_width
                                ? heading.col_width
                                : heading.label === "Bid Status"
                                  ? "180px"
                                  : undefined,
                          minWidth:
                            heading.label === "Bid Status"
                              ? "180px"
                              : heading.minWidth || heading.col_width,
                          verticalAlign: heading.field === "role" && "middle",
                          ...(stickyFirstColumn &&
                            headings?.[0]?.field === heading.field && {
                              position: "sticky",
                              left: stickyFirstColumnOffset,
                              zIndex: 3,
                              backgroundColor: "#f8fafc",
                              boxShadow: "2px 0 0 0 #e2e8f0 inset",
                              textAlign: "left",
                            }),
                        }}
                      >
                        {heading.label === "Status" &&
                        heading.additional_data !== "toggle" ? (
                          <span
                            className={
                              row.bid_status === "open"
                                ? styles.activeStatus
                                : row.bid_status === "closed" ||
                                    row.bid_status === "cancelled" ||
                                    row.bid_status === "failed"
                                  ? styles.InActiveStatus
                                  : styles.activeStatus
                            }
                          >
                            {row.bid_status || "Active"}
                          </span>
                        ) : heading.label === "Bid Status" ? (
                          (() => {
                            const statusText =
                              row.status == null ? "" : String(row.status);
                            const statusLower = statusText.trim().toLowerCase();
                            const isSuccess = statusLower === "success";

                            return (
                              <span
                                className={`${styles.bidStatus} ${isSuccess ? styles.successBid : ""}`}
                              >
                                {isSuccess && (
                                  <img
                                    src={bidSuccessImg}
                                    className={styles.bidSuccessImg}
                                    alt="Success"
                                  />
                                )}
                                {statusText || "-"}
                              </span>
                            );
                          })()
                        ) : heading.additional_data === "full_profile" ? (
                          <div className={styles.prName}>
                            <img
                              src={row.profile_image || profileImg}
                              alt={row.first_name}
                              className={styles.profile_image}
                            />
                            <span>{row[heading.field]}</span>
                          </div>
                        ) : heading.label === "Vendor" &&
                          vendorNameConfidential &&
                          ownBid &&
                          ownBid[0]?.vendor !== row?.vendor ? (
                          <span>
                            {typeof row[heading.field] === "string" &&
                              row[heading.field]?.slice(0, 1)}
                            *****
                          </span>
                        ) : vendorConfidential &&
                          ownBid &&
                          ownBid[0]?.vendor !== row?.vendor ? (
                          <span>
                            {typeof row[heading.field] === "string" &&
                              row[heading.field]?.slice(0, 1)}
                            ***
                          </span>
                        ) : heading.additional_data === "toggle" ? (
                          <span className={`${styles.flex}`}>
                            <SwitchButton
                              switchID={i}
                              onToggle={() => toggleOnChange(row.token, row)}
                              colorOn={"#59CE72"}
                              colorOff={"#CC0000"}
                              isOn={row.status}
                            />
                          </span>
                        ) : heading.additional_data === "currency" ? (
                          <span>{formatInrAmount(row[heading.field])}</span>
                        ) : heading.dowloadFile ? (
                          <span>
                            <a
                              onClick={() => {
                                let fileName = heading.compare_analytics
                                  ? row.file_name
                                  : row[heading.field]?.split("/");
                                saveAs(
                                  row[heading.field],
                                  heading.compare_analytics
                                    ? fileName
                                    : fileName[fileName?.length - 1],
                                );
                              }}
                            >
                              <ImgFrame
                                imgSrc={fileIcon}
                                customClass={styles.fileBtn}
                              />
                            </a>
                          </span>
                        ) : heading.cellType === "view" ? (
                          <span
                            className={styles.viewDescriptionBtn}
                            onClick={() => {
                              handleOpenViewDescription(row[heading.field]);
                            }}
                          >
                            View
                          </span>
                        ) : (
                          <span>
                            {row[heading.field] !== undefined &&
                            row[heading.field] !== null
                              ? row[heading.field]
                              : heading.label === "Quote Iteration" &&
                                  (row.version === null ||
                                    row.version === 0 ||
                                    row.version === "") &&
                                  hasBidIteration
                                ? "Initial"
                                : "-"}
                          </span>
                        )}
                      </td>
                    ))}

                    {actions && (
                      <td
                        className={styles.action}
                        style={{
                          position: "sticky",
                          right: 0,
                          zIndex: 2,
                          backgroundColor: "#f8fafc",
                          boxShadow: "-2px 0 0 0 #e2e8f0 inset",
                        }}
                      >
                        {viewBtn && (
                          <Tooltip
                            title={resolvedViewTooltip}
                            arrow
                            componentsProps={{
                              tooltip: {
                                sx: {
                                  fontSize: "15px",
                                  padding: "8px 12px",
                                  minHeight: "20px",
                                  fontFamily: "GilroyMedium",
                                },
                              },
                              arrow: {
                                sx: {
                                  fontSize: "18px",
                                },
                              },
                            }}
                          >
                            <span className={styles.actionTooltipWrapper}>
                              <ImgFrame
                                imgSrc={viewIcon}
                                ImgClick={() => {
                                  viewClick(row.token, row);
                                }}
                                customClass={styles.actBtn}
                              />
                            </span>
                          </Tooltip>
                        )}

                        {editBtn && (
                          <Tooltip
                            title={resolvedEditTooltip}
                            arrow
                            componentsProps={{
                              tooltip: {
                                sx: {
                                  fontSize: "15px",
                                  padding: "8px 12px",
                                  minHeight: "20px",
                                  fontFamily: "GilroyMedium",
                                },
                              },
                              arrow: {
                                sx: {
                                  fontSize: "18px",
                                },
                              },
                            }}
                          >
                            <span className={styles.actionTooltipWrapper}>
                              <ImgFrame
                                imgSrc={editIcon}
                                ImgClick={() =>
                                  itemsTable && !row.status
                                    ? ""
                                    : editClick(row.token, row)
                                }
                                customClass={`${styles.actBtn} ${
                                  itemsTable && !row.status && styles.disabled
                                }`}
                              />
                            </span>
                          </Tooltip>
                        )}

                        {deleteBtn && (
                          <Tooltip
                            title={resolvedDeleteTooltip}
                            arrow
                            componentsProps={{
                              tooltip: {
                                sx: {
                                  fontSize: "15px",
                                  padding: "8px 12px",
                                  minHeight: "20px",
                                  fontFamily: "GilroyMedium",
                                },
                              },
                              arrow: {
                                sx: {
                                  fontSize: "18px",
                                },
                              },
                            }}
                          >
                            <span className={styles.actionTooltipWrapper}>
                              <ImgFrame
                                imgSrc={dltIcon}
                                ImgClick={() => deleteClick(row.token, row)}
                                customClass={styles.actBtn}
                              />
                            </span>
                          </Tooltip>
                        )}
                      </td>
                    )}

                    {(file && org) ||
                    buyer ||
                    (ownBid && ownBid[0]?.vendor === row?.vendor) ? (
                      row.document !== "None" &&
                      row.document !== null &&
                      row.document !== "" ? (
                        <td
                          style={{
                            width: "8rem",
                            minWidth: "8rem",
                            textAlign: "center",
                          }}
                        >
                          <span>
                            <a
                              onClick={() => {
                                let fileName = row?.document?.split("/");
                                let replaceStringtoURL = row.document.replace(
                                  "https://teckost.s3.amazonaws.com/",
                                  `${cloudFrontURL}/`,
                                );
                                // saveAs(`${cloudFrontURL}/${row.document}`, fileName[fileName?.length - 1])
                                saveAs(
                                  `${replaceStringtoURL}`,
                                  fileName[fileName?.length - 1],
                                );
                              }}
                            >
                              <ImgFrame
                                imgSrc={fileIcon}
                                customClass={styles.fileBtn}
                              />
                            </a>
                          </span>
                        </td>
                      ) : (
                        <td
                          style={{
                            width: "8rem",
                            minWidth: "8rem",
                            textAlign: "center",
                          }}
                        >
                          {" "}
                          <span
                            className={styles.viewDescriptionBtn}
                            onClick={() => {
                              handleOpenViewDescription(row.description);
                            }}
                          >
                            View
                          </span>
                        </td>
                      )
                    ) : (
                      ""
                    )}

                    {ownBid && ownBid[0]?.vendor === row?.vendor && (
                      <td
                        className={styles.ownBid}
                        style={{
                          width: "11rem",
                          minWidth: "11rem",
                        }}
                      >
                        <ImgFrame
                          imgSrc={ownBidIcon}
                          customClass={styles.ownBidImage}
                        />
                        <span
                          style={{
                            marginLeft: "1rem",
                          }}
                        >
                          Own Bid
                        </span>
                      </td>
                    )}

                    {selectBidBtn && (
                      <td style={{ width: "16rem" }}>
                        <div
                          className={`${styles.flex} ${styles.SelectBidSection}`}
                        >
                          {!isSelectedBid(i) &&
                          (row.status === null ||
                            row.status === "unselected") ? (
                            <DButton
                              label="SELECT BID"
                              btnHeight="3.2rem"
                              btnWidth="12rem"
                              vendorBtn={true}
                              customClass={styles.selectBidBtn}
                              onClick={() => {
                                handleSelectBid(i, row);
                              }}
                              disabled={
                                bulkData &&
                                checkIsBidSelected
                                  ?.map((e) => e === "selected")
                                  ?.filter((e) => e === true)?.length !== 0
                              }
                            />
                          ) : row.status === "selected" ? (
                            <>
                              <span className={styles.bidSelectedText}>
                                SELECTED
                              </span>
                              <DButtonOutlined
                                label="Unselect Bid"
                                btnHeight="3.2rem"
                                btnWidth="14rem"
                                customClass={styles.unSelectBidBtn}
                                onClick={() => handleUnselectBid(i, row)}
                              />
                            </>
                          ) : (
                            <DButton
                              label="SELECT BID"
                              btnHeight="3.2rem"
                              btnWidth="12rem"
                              vendorBtn={true}
                              customClass={styles.selectBidBtn}
                              onClick={() => {
                                handleSelectBid(i, row);
                              }}
                              disabled={
                                bulkData &&
                                checkIsBidSelected
                                  ?.map((e) => e === "selected")
                                  ?.filter((e) => e === true)?.length !== 0
                              }
                            />
                          )}
                        </div>
                      </td>
                    )}
                  </tr>
                ))}
            </tbody>
          )}
        </table>
      </div>

      {isLoading && (
        <span className={styles.infoMsg}>
          <CircularProgress
            thickness={6}
            variant="indeterminate"
            disableShrink
            sx={{
              animationDuration: "450ms",
              color: "#55555580",
            }}
            size={25}
          />
        </span>
      )}

      {errorMessage && (
        <span className={styles.infoMsg}>
          {errorMessage || "No data found."}
        </span>
      )}

      <Modal
        open={descriptionPopup.open}
        closeAfterTransition
        slotProps={{
          backdrop: {
            TransitionComponent: Fade,
          },
        }}
        sx={{
          overflow: "auto",
        }}
      >
        <Fade in={descriptionPopup.open}>
          <div className={styles.flex}>
            <PopupFrame
              customClass={styles.VUPopup}
              inputChildren={viewDescriptionContent}
              poupHeading={viewDescriptionHeading}
              actionButtons={viewDescriptionAction}
              closePopup={handleCloseViewDescription}
            />
          </div>
        </Fade>
      </Modal>
    </div>
  );
};

export default memo(DataTable);
